import * as React from 'react';
import { connect } from 'react-redux';
import { makeGetNodeData } from '../../../store/FMTree/FMTReeSelectors';
import {
    FMTreeGroupData,
    FMTreeItemData,
    TreeDisplayStateType,
    TreeType,
    TreeNodeType,
} from '../../../store/FMTree/FMTreeReducer';
import { selectNode } from '../../../store/FMTree/FMTreeActions';
import { RootState } from '../../../store/index';
import { FMSelectButton, FMPopover } from 'atoms';
import { FMTreeGroupNode as GroupNode } from 'molecules';
import { FMTreeBase } from 'organisms';
const ITEM_HEIGHT = 48;

interface OwnProps {
    treeType: TreeType;
    treeDisplayState: TreeDisplayStateType;
    initialValue?: string;
    showRoot?: boolean;
    onChange?: (value: string) => void;
}

interface DispatchProps {
    selectNode: (treeDisplayState: TreeDisplayStateType, nodeType: TreeNodeType, id: string) => void;
}

interface StateProps {
    selectedNode: FMTreeGroupData | FMTreeItemData;
}

interface State {
    anchorEl: any;
    selectedItem: any;
    isSelectOpened: boolean;
}

type Props = OwnProps & DispatchProps & StateProps;

class FMDropDownTree extends React.Component<Props, State> {

    private treeRef: any;

    constructor(props: Props) {
        super(props);
        this.state = {
            anchorEl: null,
            selectedItem: props.selectedNode,
            isSelectOpened: false
        };
        this.treeRef = React.createRef();
        if (this.props.initialValue) {
            this.selectGroup(this.props.initialValue);
        }
    }

    private showSelect = (event: any) => {
        this.setState({ isSelectOpened: true, anchorEl: event.currentTarget });
    }

    public componentDidUpdate(oldProps: Props) {
        if (oldProps.selectedNode !== this.props.selectedNode) {
            this.setState({ isSelectOpened: false });
            if (this.props.onChange) {
                this.props.onChange(this.props.selectedNode.id);
            }
        }
    }

    private handleClose = () => {
        this.setState({ anchorEl: null, isSelectOpened: false });
    }

    public getSelection = () => this.props.selectedNode;

    private selectGroup = (id: string) =>
        this.props.selectNode(this.props.treeDisplayState, TreeNodeType.group, id);

    public render() {
        const { anchorEl } = this.state;

        return (
            <React.Fragment>
                <FMSelectButton
                    variant="outlined"
                    color="secondary"
                    onClick={this.showSelect}
                >
                    {this.props.selectedNode ? this.props.selectedNode.name : 'Select'}
                </FMSelectButton>
                <FMPopover
                    id="long-menu"
                    anchorEl={anchorEl}
                    open={this.state.isSelectOpened}
                    onClose={this.handleClose}
                    PaperProps={{
                        style: {
                            height: ITEM_HEIGHT * 4.5,
                            width: 200,
                        },
                    }}
                >
                    <FMTreeBase
                        ref={this.treeRef}
                        treeType={this.props.treeType}
                        treeDisplayState={this.props.treeDisplayState}
                        groupNode={GroupNode}
                        itemNode={null}
                        showRoot={this.props.showRoot}
                    />
                </FMPopover>
            </React.Fragment>
        );
    }

}

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => {

    const getNodeData = makeGetNodeData(state, ownProps.treeType);

    return {
        selectedNode: getNodeData(state, ownProps.treeDisplayState)
    };

};

const mapDispatchToProps = {
    selectNode,
};

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: OwnProps) => ({
    ...ownProps,
    ...dispatchProps,
    ...stateProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps, { forwardRef: true })(FMDropDownTree);
